module.exports = __webpack_public_path__ + "img/description-1.afb42582.png";